import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            listaAssistitiAssenti: [],
            //assistitiAssentiPathResource: "/rsaospiti/pazientisemiresidenziale",
            assistitiAssentiPathResource: "/rsaaccettazionesemiresidenziale/assenti",
            assistitiPresentiPathResource: "/rsaaccettazionesemiresidenziale/presenti",
        };
    },
    methods: {
        assistitiAssentiLoadData(filtroAssenti = null, afterLoad = null) {
            this.openShowModalLoading();
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.assistitiAssentiPathResource;
            axios
                .get(link, { params: filtroAssenti })
                .then((response) => {
                    me.listaAssistitiAssenti = response.data.data.list;
                    this.closeShowModalLoading();
                    if (afterLoad != null) {
                        afterLoad();
                    }
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    console.log("Il servizio dei regimi ha datao errore: " + error.response.status);
                });
        },
        assistitiPresentiLoadData(filtro, afterLoad = null) {
            this.openShowModalLoading();
            let me = this;
            let filtroPresenti = filtro;
            let link = process.env.VUE_APP_PATH_API + me.assistitiPresentiPathResource;
            axios
                .get(link, { params: filtroPresenti })
                .then((response) => {
                    me.listaAssistitiAssenti = response.data.data.list;
                    this.closeShowModalLoading();
                    if (afterLoad != null) {
                        afterLoad();
                    }
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore nel salvataggio della presenza";
                    me.$bvToast.toast(messaggio, {
                        title: "Erroe",
                        variant: "danger",
                        solid: true,
                    });
                    console.log("Il servizio dei regimi ha datao errore: " + error.response.status);
                });
        },
    },
};
